<template>
    <div class="cz3__product-info">
        <div class="cz3__product-info__name">
            {{label ? label : productTitle}}
        </div>

        <div class="cz3__product-info__price">
            <span class="cz3__product-info__price-value">
                <span class="font-bold uppercase flex items-center">
                    <span class="text-2xl ml-2">
                        {{defaultSubtotalPrice}}
                    </span>
                    <span class="text-sm uppercase text-gray-400 ml-2">total</span>
                </span>

                <template v-if="selectedStepV3 !== 'start'">
                    <span class="px-2 leading-[32px]">=</span>

                    <span class="font-bold uppercase flex items-center">
                        <span class="text-2xl">
                            {{defaultUnitPriceFormatted}}
                        </span>
                        <span class="text-sm uppercase text-gray-400 ml-2">base</span>
                    </span>

                    <template v-if="personalizations > 0">
                        <span class="px-2 leading-[32px]">+</span>

                        <span class="flex items-center space-x-2">
                            <span class="text-blue-500 text-2xl">
                                <span v-if="freePersonalizations > 0" class="text-red-500 text-2xl">{{$t('FREE')}}</span>
                                <span v-if="freePersonalizations > 0 && personalizations > freePersonalizations" class="px-1">+</span>
                                <span v-if="personalizations > freePersonalizations">{{customizationsPrice}}</span>
                            </span>
                            <span class="text-sm uppercase text-gray-400">{{personalizationTitle}}</span>
                        </span>
                    </template>
                </template>
            </span>
        </div>
    </div>
</template>

<style lang="scss">
    @import "../../style/variables.scss";

    #cz2.cz2 {
        .cz3__product-info {
            display: flex;
            flex-direction: row;

            justify-content: flex-start;
            align-items: center;

            padding: 0 16px;

            gap: 16px;

            @include respond-above(sm) {
                flex-direction: column;
                align-items: flex-start;

                padding: 40px 32px 0;

                gap: 24px;
            }
        }

        .cz3__product-info__name {
            flex: 1 1 0;

            font-family: $font-main;
            font-weight: 700;
            font-size: 18px;

            @include respond-above(sm) {
                font-weight: 500;
                font-size: 20px;
            }
        }

        .cz3__product-info__price {
            flex: 0 0 auto;

            text-align: center;
        }

        .cz3__product-info__price-value {
            font-family: $font-main;
            font-weight: 700;
            font-size: 16px;

            display: flex;
        }

        .cz3__product-info__price-each {
            display: block;

            font-family: $font-main;
            font-weight: 400;
            font-size: 14px;

            @include respond-above(sm) {
                display: inline;

                font-size: 16px;
            }
        }
    }
</style>

<script>
    export default {
        props: {
            label: String,
        },
        computed: {
            /**
             * Current view controller.
             */
            viewController() {
                return this.$store.state.customizer.viewController;
            },

            /**
             * Product title.
             */
            productTitle() {
                if (this.viewController && this.viewController.blueprint) {
                    return this.viewController.blueprint.name;
                }

                return '';
            },

            /**
             * Subtotal unit price.
             */
            defaultUnitPrice() {
                return this.$store.state.customizer.defaultUnitPrice;
            },

            /**
             * Subtotal unit price.
             */
            subtotalUnitPrice() {
                return this.$store.state.customizer.subtotalUnitPrice;
            },

            /**
             * Return if the default unit price does not equal the current unit price.
             * Uses string comparison for formatted values
             */
            isDiscounted() {
                return this.subtotalUnitPrice !== this.defaultUnitPrice;
            },

            selectedStepV3() {
                return this.$store.state.selectedStepV3;
            },

            defaultUnitPriceFormatted() {
                return this.$store.getters.defaultUnitPriceFormatted;
            },

            defaultSubtotalPrice() {
                return this.$store.state.customizer.defaultSubtotalPrice;
            },

            personalizations() {
                return this.$store.state.customizer.personalizations;
            },

            freePersonalizations() {
                return this.$store.state.customizer.freePersonalizations;
            },

            customizationsPrice() {
                return this.$store.state.customizer.customizationsPrice;
            },

            personalizationTitle() {
                return this.viewController.blueprint.custom['v-personalization-product-title'];
            },
        },
    };
</script>
